import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import apidata from "../API/api";
import IsLoading from "../Components/Loader/IsLoading";

export default function EventSingle() {
  const params = useParams();
  const [eventData, setEventData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getEventData = async () => {
    const response = await apidata(
      `upcomingeventretupddeview/${params?.eventId}`
    );
    setIsLoading(false);
    setEventData(response?.data);
  };

  useEffect(() => {
    getEventData();
  }, []);

  if (isLoading) {
    return <IsLoading />;
  }

  const dateTime = new Date(eventData?.date);

  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  const formatedDate = dateTime.toLocaleString("en-US", options);

  return (
    <>
      <section id="page-content-wrap">
        <div className="single-event-page-content section-padding">
          <div className="container">
            <div className="row">
              <div className="col-lg-10">
                <div>
                  <Link
                    to="/event"
                    className="btn shadowBtn textUnderRemove mb-3"
                  >
                    Go Back
                  </Link>
                </div>
                <article className="single-blog-content-wrap shadow-soft roundedImg">
                  <header className="article-head p-4">
                    <div className="single-blog-thumb">
                      <img
                        src={eventData?.image}
                        alt="Event"
                        className="img-fluid"
                      />
                    </div>
                    <div className="single-blog-meta">
                      <h2>{eventData?.title}</h2>
                      <div className="posting-info">{formatedDate}</div>
                    </div>
                  </header>
                  <section
                    className="blog-details"
                    dangerouslySetInnerHTML={{ __html: eventData?.description }}
                  />
                  <div className="text-center mb-3">
                    {eventData?.registration_link ? (
                      <a
                        className="btn btn-brand btn-brand-dark mb-3"
                        href={eventData?.registration_link}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Register
                      </a>
                    ) : (
                      ""
                    )}
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
